import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { ChevronIcon } from 'src/ui/assets/icons/arrow/ChevronIcon';
import { withConfig } from 'src/withConfig';

type SectionHeaderWrapperType = {
    isOpen: boolean;
    variant: DefaultComponentVariantType | null;
}

export const CollapseWrapper = withConfig(theme => styled('div', { label: 'CollapseWrapper' })<SectionHeaderWrapperType>`
    align-items: center;
    background: ${theme.star.collapse.competitionAndMarket.bgColor};
    color: ${theme.star.collapse.competitionAndMarket.txtColor};
    cursor: pointer;
    display: flex;
    flex-flow: row nowrap;
    gap: 8px;
    height: 32px;
    justify-content: start;
    position: relative;
    border-radius: ${theme.star.collapse.radius};
    &::after {
        border-top: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'none' : `1px solid ${theme.star.collapse.competitionAndMarket.borderColor}`};
        inset: auto 0 0;
        content: '';
        opacity: ${({ isOpen }):string => isOpen ? '0' : '1'};
        position: absolute;
        transition: opacity .2s ease;
        width: 100%;
    }
`);

export const CollapseLabel = styled('div', { label: 'CollapseLabel' })`
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
    gap: 8px;
    justify-content: start;
    overflow: hidden;
    padding: 8px;
`;

export const ChevronWrapper = withConfig(theme => styled(ChevronIcon, { label: 'ChevronWrapper' })`
    fill: ${theme.star.collapse.competitionAndMarket.bgColorSecondary};
    flex: 0 0 16px;
    width: 16px;
`);

export const SectionTitle = withConfig(theme => styled('h4', { label: 'SectionTitle' })`
    align-items: center;
    display: flex;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    gap: 8px;
    line-height: 1.3334;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    user-select: none;
    white-space: nowrap;
`);

export const CollapseChildren = styled('div', { label: 'CollapseChildren' })`
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    align-self: stretch;
`;
